import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./filterBox.style.scss";
import { useAllThingsLists } from '../../../Contexts/allThingsList.context.jsx';

const FilterBox = ({
  readOnly = false,
  placeholder = "Enter text here...",
  displayValue = "",
  chosenFields = [],
  onFilterChange = () => { },
}) => {
  const { filterBoxValue, filterBoxDropdown, updateFilterBoxValue, updateFilterBoxDropdown, updateIsListFiltered } = useAllThingsLists();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const inputRef = useRef(null);

  // 🔥 **Sync UI when `filterBoxValue` updates from the context**
  useEffect(() => {
    // ✅ Keep UI in sync with context
  }, [filterBoxValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    updateFilterBoxValue(value); // ✅ Update Context
    if (value.length > 0) {
      updateIsListFiltered(true);
      return;
    }
    updateIsListFiltered(false);
    // if (onFilterChange) {
    //   onFilterChange(value, filterBoxDropdown); 
    // }
  };

  const handleClear = () => {
    updateIsListFiltered(false);
    updateFilterBoxValue(""); // ✅ Clear filter in context
    // if (onFilterChange) {
    //   onFilterChange("", filterBoxDropdown); 
    // }
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const filterBoxDisplay = filterBoxDropdown === "UFL24" ? "UFL" : filterBoxDropdown.toUpperCase();

  const handleFieldClick = (field) => {
    let out = '';
    switch (field.substr(0, 3)) {
      case "Las": out = "LN"; break;
      case "Fir": out = "FN"; break;
      case "Gra": out = "GR"; break;
      case "Not": out = "NT"; break;
      case "Res": out = "All"; break;
      case "Sch": out = "SCH"; break;
      case "Exp": out = "EXP"; break;
      case "Gen": out = "GEN"; break;
      case "Cal": out = "CGR"; break;
      case "Hig": out = "GR"; break;
      case "FCY": out = "FCY"; break;
      case "UFL": out = "UFL24"; break;
      default: out = field.substr(0, 3).toUpperCase(); break; // Fallback: Use first 3 uppercase
    }
    updateFilterBoxValue("");
    updateIsListFiltered(false);
    updateFilterBoxDropdown(out);
    setDropdownOpen(false);
    setTimeout(() => {
      inputRef.current?.focus(); // 🔥 Refocus input after dropdown closes
    }, 100);
    // if (onFilterChange) {
    //   onFilterChange(inputValue, out);
    // }
  };

  // const mainFields = ["Reset", "Last Name", "First Name", "Gen Position", "School", "CFL Team", "NFL Team", "High Grade (>=)"];
  // eslint-disable-next-line
  // const noteFields = [...mainFields, "Note"];
  // eslint-disable-next-line
  // const scoutFields = [...mainFields, "Grade (>=)", "Calc Grade (>=)"];
  // eslint-disable-next-line
  // const [fields, setFields] = useState(mainFields);

  // useEffect(() => {
  //     switch (whichOneLine) {
  //         case 'Main': setFields(mainFields); break;
  //         case 'Note': setFields(noteFields); break;
  //         case 'Scout': setFields(scoutFields); break;
  //         default: setFields(mainFields); break;
  //     }
  // }, [whichOneLine]);

  return (
    <div className="filter-box-container">
      <div className="filter-drop-button" onClick={toggleDropdown}>
        {filterBoxDisplay}
      </div>
      <input
        ref={inputRef} // 🔥 Attach ref to input field
        type="text"
        className="filter-box-input"
        placeholder={placeholder}
        value={displayValue}
        onChange={handleInputChange}
        readOnly={readOnly}
        style={{
          backgroundColor: readOnly ? "#ccc" : "#fff",
          cursor: readOnly ? "not-allowed" : "text",
        }}
      />
      {filterBoxValue && !readOnly && (
        <button className="clear-button" onClick={handleClear} aria-label="Clear input">
          ✕
        </button>
      )}
      {dropdownOpen && (
        <div className="dropdown-content">
          {chosenFields.map((field) => (
            <button
              key={field}
              className={`dropdown-button ${filterBoxDropdown === field ? "selected" : ""}`}
              onClick={() => handleFieldClick(field)}
            >
              {field}
            </button>
          ))}
          {/* 🔹 Add a horizontal line here */}
          <hr className="dropdown-divider" />

          {/* 🔹 High Grade (>=) button below the line */}
          <button
            className={`dropdown-button ${filterBoxDropdown === "High Grade (>=)" ? "selected" : ""}`}
            onClick={() => handleFieldClick("High Grade (>=)")}
          >
            High Grade (&gt;=)
          </button>
        </div>
      )}
    </div>
  );
};

FilterBox.propTypes = {
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  chosenFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  onFilterChange: PropTypes.func,
};

export default FilterBox;
